import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton, PlayStoreButton } from './ui/StoreButtons';

const CTA = () => {
  return (
    <section id="download" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-primary">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)', backgroundSize: '30px 30px' }} />
      </div>

      {/* Decorative blobs */}
      <div className="absolute top-0 left-1/4 w-72 h-72 bg-teal/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-primary-dark/40 rounded-full blur-3xl" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-4xl mb-4">🏓</p>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Ready to play your <br className="hidden sm:block" />best pickleball ever?
          </h2>
          <p className="text-white/80 text-lg md:text-xl mb-10 max-w-xl mx-auto">
            Download Pickleball Insight Coach for free and start your first match analysis today. No coach needed.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <AppStoreButton />
            <PlayStoreButton />
          </div>

          <div className="flex items-center justify-center gap-6 text-white/60 text-sm flex-wrap">
            <span>✓ Free to download</span>
            <span>✓ No credit card required</span>
            <span>✓ iOS & Android</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;